import ThisModule from "./ExternalCommitmentsTable";

export default ThisModule;
